import React from 'react';
import { Box, useColorModeValue } from '@chakra-ui/react';

import { TermsAndConditionsContent } from 'clipsal-cortex-ui/src/components/TermsAndConditionsContent';

import { ProfilePageBase } from '../ProfilePageBase';

export const TermsAndConditions = () => {
  const background = useColorModeValue('white', 'gray.900');

  return (
    <ProfilePageBase title={'Terms & Conditions'}>
      <Box p={4} background={background} pt={6}>
        <TermsAndConditionsContent />
      </Box>
    </ProfilePageBase>
  );
};
